/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EnqueteFormQuestionUserVariableDefinitionFragmentDoc } from '../../features/enquete/components/EnqueteForm/EnqueteFormQuestion.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EnqueteAnsweredChatMessageInput = {
  body: string;
  selections?: Array<string> | null | undefined;
};

export type EnqueteInput = {
  answeredChatMessage?: EnqueteAnsweredChatMessageInput | null | undefined;
  questions: Array<EnqueteQuestionInput>;
  title: string;
};

export type EnqueteQuestionInput = {
  /** 新規で作成された EnqueteQuestionInput は null である */
  guid?: string | number | null | undefined;
  isAnswerRequired: boolean;
  questionText: string;
  userVariableDefinitionGUID: string | number;
};

export type IssueEnqueteAnswersCsvFileDownloadUrlInput = {
  enqueteGUID: string | number;
};

export type UpdateEnqueteInput = {
  enquete: EnqueteInput;
  guid: string | number;
};

export type EnqueteEditPageContentEnquetePayloadFragment = { enquete: { guid: string, title: string, answerEnqueteLiffAppPageUrl: string | null, answerCount: number, questions: Array<{ guid: string, questionText: string, isAnswerRequired: boolean, userVariableDefinition: { __typename: 'UserVariableDefinition', guid: string, name: string, value:
          | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ __typename: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ __typename: 'UserVariableDefinitionValueSelectOption', guid: string, name: string }> }
          | { __typename: 'UserVariableDefinitionValueString', void: any }
          | { __typename: 'UserVariableDefinitionValueText', void: any }
         } }>, answeredChatMessage: { body: string, selections: Array<string> | null } | null } };

export type EnqueteEditPageContentUserVariableDefinitionFragment = { guid: string, name: string, value:
    | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
    | { __typename: 'UserVariableDefinitionValueString', void: any }
    | { __typename: 'UserVariableDefinitionValueText', void: any }
   };

export type UpdateEnqueteMutationVariables = Exact<{
  input: Types.UpdateEnqueteInput;
}>;


export type UpdateEnqueteMutation = { updateEnquete: { void: any } };

export type IssueEnqueteAnswersCsvFileDownloadUrlMutationVariables = Exact<{
  input: Types.IssueEnqueteAnswersCsvFileDownloadUrlInput;
}>;


export type IssueEnqueteAnswersCsvFileDownloadUrlMutation = { issueEnqueteAnswersCsvFileDownloadURL: { downloadURL: string } };

export const EnqueteEditPageContentEnquetePayloadFragmentDoc = gql`
    fragment EnqueteEditPageContentEnquetePayload on EnquetePayload {
  enquete {
    guid
    title
    questions {
      guid
      questionText
      isAnswerRequired
      userVariableDefinition {
        __typename
        guid
        name
        value {
          __typename
          ... on UserVariableDefinitionValueString {
            __typename
            void
          }
          ... on UserVariableDefinitionValueText {
            __typename
            void
          }
          ... on UserVariableDefinitionValueSelect {
            __typename
            options {
              __typename
              guid
              name
            }
          }
          ... on UserVariableDefinitionValueMultipleSelect {
            __typename
            options {
              __typename
              guid
              name
            }
          }
        }
      }
    }
    answeredChatMessage {
      body
      selections
    }
    answerEnqueteLiffAppPageUrl
    answerCount
  }
}
    `;
export const EnqueteEditPageContentUserVariableDefinitionFragmentDoc = gql`
    fragment EnqueteEditPageContentUserVariableDefinition on UserVariableDefinition {
  ...EnqueteFormQuestionUserVariableDefinition
}
    ${EnqueteFormQuestionUserVariableDefinitionFragmentDoc}`;
export const UpdateEnqueteDocument = gql`
    mutation UpdateEnquete($input: UpdateEnqueteInput!) {
  updateEnquete(input: $input) {
    void
  }
}
    `;

/**
 * __useUpdateEnqueteMutation__
 *
 * To run a mutation, you first call `useUpdateEnqueteMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEnqueteMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateEnqueteMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEnqueteMutation(options: VueApolloComposable.UseMutationOptions<UpdateEnqueteMutation, UpdateEnqueteMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateEnqueteMutation, UpdateEnqueteMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateEnqueteMutation, UpdateEnqueteMutationVariables>(UpdateEnqueteDocument, options);
}
export type UpdateEnqueteMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateEnqueteMutation, UpdateEnqueteMutationVariables>;
export const IssueEnqueteAnswersCsvFileDownloadUrlDocument = gql`
    mutation IssueEnqueteAnswersCsvFileDownloadURL($input: IssueEnqueteAnswersCsvFileDownloadURLInput!) {
  issueEnqueteAnswersCsvFileDownloadURL(input: $input) {
    downloadURL
  }
}
    `;

/**
 * __useIssueEnqueteAnswersCsvFileDownloadUrlMutation__
 *
 * To run a mutation, you first call `useIssueEnqueteAnswersCsvFileDownloadUrlMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useIssueEnqueteAnswersCsvFileDownloadUrlMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useIssueEnqueteAnswersCsvFileDownloadUrlMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useIssueEnqueteAnswersCsvFileDownloadUrlMutation(options: VueApolloComposable.UseMutationOptions<IssueEnqueteAnswersCsvFileDownloadUrlMutation, IssueEnqueteAnswersCsvFileDownloadUrlMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<IssueEnqueteAnswersCsvFileDownloadUrlMutation, IssueEnqueteAnswersCsvFileDownloadUrlMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<IssueEnqueteAnswersCsvFileDownloadUrlMutation, IssueEnqueteAnswersCsvFileDownloadUrlMutationVariables>(IssueEnqueteAnswersCsvFileDownloadUrlDocument, options);
}
export type IssueEnqueteAnswersCsvFileDownloadUrlMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<IssueEnqueteAnswersCsvFileDownloadUrlMutation, IssueEnqueteAnswersCsvFileDownloadUrlMutationVariables>;